<template>
    <div class="decisions-table">
        <section class="decisions-title">
            {{ $t('funnel.debug.decision') }}
        </section>

        <DsTableGrid
            ref="decisionRef"
            :data="decisions"
        >
            <DsTableGridColumn
                :label="$t('funnel.edit.decision.diamond.debug.label.id')"
                prop="Id"
                width="60"
                data-qa="decision-diamond-debug-column-id"
            />

            <DsTableGridColumn
                :label="$t('funnel.edit.decision.diamond.debug.label.rule.group.id')"
                prop="RuleGroupId"
                width="80"
                data-qa="decision-diamond-debug-column-rule-group-id"
            />

            <DsTableGridColumn
                :label="$t('funnel.edit.decision.diamond.debug.label.published.rule.group.id')"
                prop="PublishedRuleGroupId"
                width="120"
                data-qa="decision-diamond-debug-column-published-rule-group-id"
            />

            <DsTableGridColumn
                :label="$t('funnel.edit.decision.diamond.debug.label.content.publishing.id')"
                prop="ContentPublishingId"
                width="120"
                data-qa="decision-diamond-debug-column-content-publishing-id"
            />

            <DsTableGridColumn
                :label="$t('funnel.edit.decision.diamond.debug.label.date.created')"
                prop="DateCreated"
                width="100"
                data-qa="decision-diamond-debug-column-date-created"
            />

            <DsTableGridColumn
                :label="$t('funnel.edit.decision.diamond.debug.label.last.updated')"
                prop="LastUpdated"
                width="100"
                data-qa="decision-diamond-debug-column-last-updated"
            />

            <DsTableGridColumn
                :label="$t('funnel.edit.decision.diamond.debug.label.default.flow')"
                prop="DefaultFlow"
                width="100"
                data-qa="decision-diamond-debug-column-default-flow"
            />

            <DsTableGridColumn
                :label="$t('funnel.edit.decision.diamond.debug.label.published.default.flow')"
                prop="PublishedDefaultFlow"
                width="100"
                data-qa="decision-diamond-debug-column-published-default-flow"
            />
        </DsTableGrid>
    </div>
</template>

<script>
export default {
    props: {
        decisions: {
            type: Array,
            required: true,
        },
    },
};

</script>

<style lang="scss" scoped>
.decisions-table {
    :deep(th .cell) {
        word-wrap: break-word;
        white-space: break-spaces;
    }

    .decisions-title {
        font-weight: $font-weight-bold;
        margin: $spacing-125 0 $spacing-250 0;
    }
}
</style>
